export default "__VITE_ASSET__rw8WKf2b__"